import { useMemo } from 'react';
import * as d3 from 'd3';

export const Axis = ({ domain = [0, 100], range = [0, 290] }) => {
  const ticks = useMemo(() => {
    const xScale = d3.scaleLinear().domain(domain).range(range);
    const width = range[1] - range[0];
    const pixelsPerTick = 50;
    const numberOfTicksTarget = Math.max(1, Math.floor(width / pixelsPerTick));
    const stuff = xScale.ticks(numberOfTicksTarget).map((value) => ({
      value,
      xOffset: xScale(value),
    }));
    // console.log(stuff);
    return stuff;
  }, [domain.join('-'), range.join('-')]);
  return (
    <svg style={{ overflow: 'visible' }}>
      <path
        d={['M', range[0], 6, 'v', -6, 'H', range[1], 'v', 6].join(' ')}
        fill="none"
        stroke="currentColor"
      />
      {ticks.map(({ value, xOffset }) => (
        <g key={value} transform={`translate(${xOffset}, 0)`}>
          <line y2="6" stroke="currentColor" />
          <text
            key={value}
            style={{
              fontSize: '10px',
              textAnchor: 'middle',
              transform: 'translateY(20px)',
              fill: 'currentColor',
            }}
          >
            {value * 1000}ft
          </text>
        </g>
      ))}
    </svg>
  );
};
